import React, { useEffect, useState } from "react";
import RigthPanel from "@/ui-controls/RigthPanel";
import { Customer } from "@/api/customers";
import NewCustomerForm from "@/components/customers/NewCustomerForm";

interface Props {
  customer: Customer;
  onUpdate: (customer: Customer) => any;
  onClose: () => any;
}

const UpdateCustomer = (props: Props) => {
  useEffect(() => {
    setIPanelOpen(props.customer !== undefined);
  }, [props.customer]);

  const onCloseUpdateAppPanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <RigthPanel
        header="Edit Customer"
        isOpen={isPanelOpen}
        dismissPanel={onCloseUpdateAppPanel}
        childComponent={NewCustomerForm}
        childProps={{
          customer: props.customer,
          onClose: () => onCloseUpdateAppPanel(),
          onUpdate: (customer: Customer) => {
            props.onUpdate(customer);
            onCloseUpdateAppPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default UpdateCustomer;
